import { RouteComponentProps } from 'react-router-dom'
import AccessWrapper from '../../components/_shared/AccessWrapper'
import { PAGES } from '../../services/constants'
import { UserAddPage } from './UserAddPage'

const UserAdd = (props: RouteComponentProps) => {
  return (
    <AccessWrapper page={PAGES.users} isWriteOnly>
      <UserAddPage {...props} />
    </AccessWrapper>
  )
}

export default UserAdd
